import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Button from '@mui/material/Button'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Box from '@mui/material/Box'
import EditarIcon from '@mui/icons-material/Edit';
import ResumenIcon from '@mui/icons-material/Assignment';
import CajeroAccionesRemotasIcon from '@mui/icons-material/SettingsRemote'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Receipt as ReceiptIcon,
} from '@mui/icons-material';

const session = require('../../config/session')

function Row(props) {

  const {cajero} = props
  const [open, setOpen] = React.useState(false)

  var entidades = []

  if (cajero.entidades != null) {
    const MAX_ENTIDADES = 5
    const listaEntidades = cajero.entidades.split('**-**')
    entidades = listaEntidades.slice(0, MAX_ENTIDADES).map((entidad, idx) => (
      <span key={`entidad-${idx}`}>* {entidad}<br /></span>
    ))
    if (listaEntidades.length > MAX_ENTIDADES) {
      const restantes = listaEntidades.length - MAX_ENTIDADES
      entidades.push(
        <span key="entidad-mas" style={{ fontStyle: 'italic', color: '#555' }}>
          + {restantes} {restantes === 1 ? 'entidad' : 'entidades'}
        </span>
      )
    }
  }


  var estado = ""

  switch(cajero.estado) {
    case 'I':
      estado = 'Inactivo'
      break
    case 'A':
      estado = 'Activo'
      break
	default:
		estado = 'Inactivo'
		break
  }

  return (
	  <React.Fragment>
	    <TableRow>
	      <TableCell>
	        <IconButton
	          aria-label="expand row"
	          size="small"
	          onClick={() => setOpen(!open)}
	        >
	          {open ? <KeyboardArrowUpIcon />:<KeyboardArrowDownIcon />}
	        </IconButton>
	      </TableCell>
	      <TableCell>
	          {cajero.alias}
	      </TableCell>
	      <TableCell>
	        {cajero.codigo}
	      </TableCell>
	      <TableCell>
	        {entidades}
	      </TableCell>
	      <TableCell>
	        {cajero.pais}
	        <br />
	        {cajero.ciudad}
	      </TableCell>
	      <TableCell>
	        {estado}
	        <br />
	        {cajero.estado_operativo}
	      </TableCell>
	      <TableCell>
	      {
	          session.checkPermiso('acceder_cajeros_editar') && 
	          <Link to={
	            {pathname: '/dashboard/cajeros/editar',
	            state: {id_cajero: cajero.id}}}
	            style={{ textDecoration: 'none' }}>
	              <Button variant="contained" endIcon={<EditarIcon />} color="primary" size='small' fullWidth sx={{marginBottom: 1}}>Editar</Button>
	          </Link>
	        }
	        {
	          session.checkPermiso('acceder_cajeros_resumen') && 
	          <Link to={
	            {pathname: '/dashboard/cajeros/resumen',
	            state: {id_cajero: cajero.id}}}
	            style={{ textDecoration: 'none' }}>
	              <Button variant="contained" endIcon={<ResumenIcon />} color="primary" size='small' fullWidth sx={{marginBottom: 1}}>Resumen</Button>
	          </Link>
	        }
	        {
	          session.checkPermiso('acceder_cajeros_acciones_remotas') && 
	          <Link to={
	            {pathname: '/dashboard/cajeros/accionesremotas',
	            state: {id_cajero: cajero.id}}}
	            style={{ textDecoration: 'none' }}>
	              <Button variant="contained" endIcon={<CajeroAccionesRemotasIcon />} color="primary" size='small' fullWidth sx={{marginBottom: 1}}>Acciones</Button>
	          </Link>
	        }
	      </TableCell>
	    </TableRow>
	    <TableRow>
	    	<TableCell style={{paddingTop: 0, paddingBottom: 0}} colSpan={10}>
		        <Collapse in={open} timeout="auto" unmountOnExit>
				<Box mb={4} mt={4}>
					<Box display="flex" alignItems="center" mb={2} sx={{ mr: 5 }}>
					<ReceiptIcon color="primary" sx={{ mr: 1 }} />
					<Typography variant="subtitle1" fontWeight="bold">
						Detalles del cajero
					</Typography>
				</Box>
				<Divider sx={{ mb: 2 }} />
				<Table size="small" sx={{
					'& th': {
					backgroundColor: 'action.selected',
					fontWeight: 'bold'
					},
					'& td, & th': {
					py: 1,
					px: 2,
					verticalAlign: 'top'
					}
				}}>
					<TableHead>
						<TableRow>
							<TableCell sx={{ fontWeight: 'bold' }}>Fecha registro</TableCell>
							<TableCell sx={{ fontWeight: 'bold' }}>Serial</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<TableRow>
							<TableCell>
							{cajero.fecha_registro}
							</TableCell>
							<TableCell>
							{cajero.serial}
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
				</Box>
	          </Collapse>
	         </TableCell>
	        </TableRow>
    </React.Fragment>
  );


}


class CajerosTable extends Component {

  /* constructor(props) {
    super(props)
  } */

  componentDidMount() {
  }

  render() {
    const cajeros = this.props.cajeros

    const columns = [
	  {field: "desplegable", headerName: "", width: 10},
      {field: "alias", headerName: 'Alias', width: 220},
      {field: "codigo", headerName: 'Codigo', width: 150},
      {field: "entidades", headerName: 'Entidades', width: 250},
      {field: "pais", headerName: 'pais', width: 150},
      {field: "estado", headerName: 'Estado', width: 100},
      {field: "", headerName: '', width: 100},
    ]

    return (
      <Box sx={{ 
        width: '100%',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        mb: 3
      }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{
                  '& th': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    fontWeight: 'fontWeightBold',
                    fontSize: '0.8rem',
                    py: 1.5,
                    px: 2
                  }
                }}>
                {columns.map((column) => {
                  return(
                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {cajeros.map((cajero, idx) => {
                return(
                  <Row key={idx} cajero={cajero} />
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    )
  }
}

export default CajerosTable;
